import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { fetchMyApiKeys, generateMyApiKey, revokeMyApiKey } from '../actions/apiKeys.actions';
import ListState from '../states/list.state';

const initialState: ListState = {
  loading: false,
  data: [],
  error: null,
  meta: null,
};

const myApiKeysSlice = createSlice({
  name: 'myApiKeys',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMyApiKeys.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMyApiKeys.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.data = action.payload.data;
        state.meta = action.payload.meta;
      })
      .addCase(fetchMyApiKeys.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload ?? null;
      })

      .addCase(generateMyApiKey.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(generateMyApiKey.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        // Reflect the new key on its spa row without a refetch.
        state.data = [...state.data].map((row: any) =>
          row?.spaGuid === action.payload?.spaGuid
            ? { ...row, apiKey: action.payload?.apiKey, hasActiveKey: true }
            : row
        );
      })
      .addCase(generateMyApiKey.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload ?? null;
      })

      .addCase(revokeMyApiKey.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(revokeMyApiKey.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.data = [...state.data].map((row: any) =>
          row?.spaGuid === action.payload?.spaGuid
            ? { ...row, apiKey: null, hasActiveKey: false }
            : row
        );
      })
      .addCase(revokeMyApiKey.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload ?? null;
      });
  },
});

export const { clearError } = myApiKeysSlice.actions;
export default myApiKeysSlice.reducer;
